import { render, staticRenderFns } from "./TabelProdukHukum.vue?vue&type=template&id=0d08e1e8"
import script from "./TabelProdukHukum.vue?vue&type=script&lang=js"
export * from "./TabelProdukHukum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports